import { Injectable } from '@angular/core';
import { catchError, lastValueFrom, map, Observable, tap, throwError } from 'rxjs';
import { ApiEndpointService } from './api-endpoint.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ToastAlertService } from 'src/app/shared/utils/toast.service';
import { profile } from 'console';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {
  constructor(private http: HttpClient) { }

  public getMembershipPlans(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.MEMBERSHIP);

    return this.http.get(url).pipe(
      map((response: any): any => {
        return response.data || [];
      }),
      catchError((fault: HttpErrorResponse) => {
        return throwError(() => fault);
      })
    );
  }

  public getMembershipById(URL ): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.MEMBERSHIP) +"/"+URL;

    return this.http.get(url).pipe(
      map((response: any): any => {
        return response.data || [];
      }),
      catchError((fault: HttpErrorResponse) => {
        return throwError(() => fault);
      })
    );
  }

  public gateWayClientIdData(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) + "gateways"

    return this.http.get(url).pipe(
      map((response: any): any => {
        return response.data || [];
      }),
      catchError((fault: HttpErrorResponse) => {
        return throwError(() => fault);
      })
    );
  }

  public getCouponList(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) + "coupons"

    return this.http.get(url).pipe(
      map((response: any): any => {
        return response.data || [];
      }),
      catchError((fault: HttpErrorResponse) => {
        return throwError(() => fault);
      })
    );
  }
  public getOrderList(page: number = 1, limit: number = 10): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) + 'orders?page=' + page + '&limit=' + limit;

    return this.http.get(url).pipe(
      map((response: any): any => {
        return response.data || [];
      }),
      catchError((fault: HttpErrorResponse) => {
        return throwError(() => fault);
      })
    );
  }

  public applyCoupon(type,payload): Observable<any> {
    const membershipActive= type ==='membership'? '/membership':''
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) + 'coupon/verify' + membershipActive;
    return this.http.post(url, payload).pipe(
      map((response: any): any => {
        return response;
      }),
      catchError((fault: HttpErrorResponse) => {

        return throwError(() => fault);
      })
    );
  }
  
  public createOrderBy(payload): Observable<any>{
    const url =ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) +'create-order';
    return this.http.post(url, payload).pipe(
      map((response: any): any => {
        return response;
      }),
      catchError((fault: HttpErrorResponse) => {

        return throwError(() => fault);
      })
    );
  }
  public capturePaypalOrder(id: string): Promise<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) + 'paypal/capture-order/' + id;
    return lastValueFrom(
      this.http.post(url, {}).pipe(
        map((response: any): any => {
          return response;
        }),
        catchError((fault: HttpErrorResponse) => {
          return throwError(() => fault);
        })
      )
    );
  }

  public createTransaction(payLoad): Observable<any>{
    const url =ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) +'create-transaction';
    return this.http.post(url, payLoad).pipe(
      map((response: any): any => {
        return response;
      }),
      catchError((fault: HttpErrorResponse) => {

        return throwError(() => fault);
      })
    );
  }
 
  public createDiscountedTransaction(payLoad): Observable<any>{
    const url =ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) +'discounted/create-order';
    return this.http.post(url, payLoad).pipe(
      map((response: any): any => {
        return response;
      }),
      catchError((fault: HttpErrorResponse) => {

        return throwError(() => fault);
      })
    );
  }

   public getEventById(moduleType,moduleTypeId ): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) +"module-pricing/"+moduleType +"/"+moduleTypeId;

    return this.http.get(url).pipe(
      map((response: any): any => {
        return response.data || [];
      }),
      catchError((fault: HttpErrorResponse) => {
        return throwError(() => fault);
      })
    );
  }

 public getEventVerifyPayment(moduleType,moduleTypeId,submissionId,programRoundsId? ): Observable<any> {
   let moduleTypeSubId= programRoundsId !=null? "/" +programRoundsId:''
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) +"verify/"+moduleType +"/"+moduleTypeId +"/"+(submissionId ?? '') + moduleTypeSubId;

    return this.http.get(url).pipe(
      map((response: any): any => {
        return response.data || [];
      }),
      catchError((fault: HttpErrorResponse) => {
        return throwError(() => fault);
      })
    );
  }

  public getRoundPricing(moduleType: string, moduleTypeId: number, moduleTypeSubId: number,submissionId?: number): Observable<any> {
  const baseUrl = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT);
  const url = `${baseUrl}round-pricing/${moduleType}/${moduleTypeId}/${moduleTypeSubId}/${submissionId ?? ''}`;

  return this.http.get<any>(url).pipe(
    map(response => response.data ?? []),
    catchError((error: HttpErrorResponse) => throwError(() => error))
  );
}
  public getPreviousOrder(moduleType: string, moduleTypeId: number, submissionId: number): Observable<any> {
  const baseUrl = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT);
  const url = `${baseUrl}previous_order/${moduleType}/${moduleTypeId}/${submissionId ?? ''}`;

  return this.http.get<any>(url).pipe(
    map(response => response.data ?? []),
    catchError((error: HttpErrorResponse) => throwError(() => error))
  );
}

public getPreviousTransationDetails(moduleType: string, moduleTypeId: number, submissionId: number): Observable<any> {
  const baseUrl = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT);
  const url = `${baseUrl}applicant_payments/${moduleType}/${moduleTypeId}/${submissionId ?? ''}`;

  return this.http.get<any>(url).pipe(
    map(response => response.data ?? []),
    catchError((error: HttpErrorResponse) => throwError(() => error))
  );
}
public getActivePlan(profileType: string, profileUUID: string): Observable<any> {
  const baseUrl = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.MEMBERSHIP);
  const url = `${baseUrl}/last/${profileType}/${profileUUID} `;

  return this.http.get<any>(url).pipe(
    map(response => response),
    catchError((error: HttpErrorResponse) => throwError(() => error))
  );
}

 public getPurchasePlan(profileType: string, profileUUID: string): Observable<any> {
  const baseUrl = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.MEMBERSHIP);
  const url = `${baseUrl}/history/${profileType}/${profileUUID} `;

  return this.http.get<any>(url).pipe(
    map(response => response.data ?? []),
    catchError((error: HttpErrorResponse) => throwError(() => error))
  );
}

 public getMembershipPalns(profileType): Observable<any> {
  const baseUrl = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.MEMBERSHIP);
  const url = `${baseUrl}/types/${profileType}`;

  return this.http.get<any>(url).pipe(
    map(response => response.data ?? []),
    catchError((error: HttpErrorResponse) => throwError(() => error))
  );
}
/**
   * List proforma invoices for a (profileType, profileId). Mirrors the
   * memberships history endpoint shape.
   */
  public getProformaInvoicesByProfile(profileType: string, profileUUID: string): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT)
      + `proforma-invoices/history/${profileType}/${profileUUID}`;
    return this.http.get(url).pipe(
      map((response: any) => response?.data || []),
      catchError((fault: HttpErrorResponse) => throwError(() => fault))
    );
  }

  /**
   * Fetch the printable HTML for a single proforma invoice (scoped to
   * a profile so users can only render their own).
   */
  public getProformaInvoiceHtml(id: number, profileType: string, profileId: number): Observable<string> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT)
      + `proforma-invoices/${id}/render/${profileType}/${profileId}`;
    return this.http.get(url, { responseType: 'text' as 'json' }).pipe(
      map((res: any) => res as string),
      catchError((fault: HttpErrorResponse) => throwError(() => fault))
    );
  }

  /**
   * Get the latest non-success (pending/failed/dropped/cancelled) order
   * for a moduleType + userId. Used by the membership page to detect
   * in-flight or failed payment attempts.
   */
  public getLatestOrderStatus(moduleType: string, profileUUID: string): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT)
      + `latest-order-status/${moduleType}/${profileUUID}`;
    return this.http.get(url).pipe(
      map((response: any) => response?.data || null),
      catchError((fault: HttpErrorResponse) => throwError(() => fault))
    );
  }

  public verifyEasebuzzStatus(txnid: string): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PAYMENT) + `easebuzz/verify-status/${txnid}`;
    return this.http.get(url).pipe(
      map((response: any) => response?.data),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  public upgradeMembership(payLoad): Observable<any>{
    const url =ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.MEMBERSHIP) +'/upgrade-request';
    return this.http.post(url, payLoad).pipe(
      map((response: any): any => {
        return response;
      }),
      catchError((fault: HttpErrorResponse) => {

        return throwError(() => fault);
      })
    );
  }
  
  public getAlreadyUpgraded(currentMembershipTypeId:number,profileType: string, profileId: number):Observable<any>{
  const baseUrl = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.MEMBERSHIP);
  const url = `${baseUrl}/upgrade-request/${currentMembershipTypeId}/${profileType}/${profileId}`;

  return this.http.get<any>(url).pipe(
    map(response => response),
    catchError((error: HttpErrorResponse) => throwError(() => error))
  );
  }
}
